/**
 * Defines at what "Stage" an application is in.
 * This is a combination of the "status" of the application,
 * as well as a "filter", some conditional logic on the data
 */
export const APPLICATION_STAGES = {
    // Stage 1:
    empty: {
        stage: 1,
        status: "in-progress",
        filter: (x) => x.bio === undefined && x.details === undefined,
    },
    inProgress: {
        stage: 1,
        status: "in-progress",
        filter: (x) => (x.bio !== undefined && x.details === undefined) ||
            (x.bio === undefined && x.details !== undefined),
    },
    needsApproval: {
        stage: 1,
        status: "in-progress",
        filter: (x) => x.bio !== undefined && x.details !== undefined,
    },
    rejected: {
        stage: 1,
        status: "waitlisted",
        filter: undefined,
    },
    // Stage 2:
    approvedComplete: {
        stage: 2,
        status: "approved",
        filter: (x) => x.creditCardId !== undefined &&
            x.subscription !== undefined &&
            x.stripe.status === "complete",
    },
    approvedIncomplete: {
        stage: 2,
        status: "approved",
        filter: (x) => x.creditCardId === undefined ||
            x.subscription === undefined ||
            x.stripe.status !== "complete",
    },
    created: {
        stage: 2,
        status: "profile-created",
        filter: undefined,
    },
};
// Ensures that ApplicationStages matches our desired typing, while allowing
// stricter typing from the const export
void APPLICATION_STAGES;
//# sourceMappingURL=application-stages.js.map